(function () {
  'use strict';
  var section = document.querySelector('.awc-homepage');
  if (!section) return;

  var revealEls = section.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  /* 2026-07-04: hero must never wait for the observer, reveal immediately on init */
  section.querySelectorAll('.awc-hero .reveal, .awc-hero .reveal-left, .awc-hero .reveal-right').forEach(function (el) { el.classList.add('is-visible'); });
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ============================================================
     3D TILT EFFECT, All cards
  ============================================================ */
  var tiltSelectors = '.condition-card, .service-card, .team-card, .credential-badge, .review-card';
  section.querySelectorAll(tiltSelectors).forEach(function (card) {
    card.style.transformStyle = 'preserve-3d';
    card.style.transition = 'transform 0.4s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.4s ease';
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      var maxTilt = card.classList.contains('team-card') ? 3.5 : 5;
      var lift = card.classList.contains('credential-badge') ? -4 : -8;
      card.style.transform = 'translateY(' + lift + 'px) perspective(900px) rotateX(' + (-y * maxTilt) + 'deg) rotateY(' + (x * maxTilt) + 'deg) scale3d(1.01, 1.01, 1.01)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
    card.addEventListener('mouseenter', function () {
      card.style.willChange = 'transform';
    });
  });

  /* ============================================================
     MAGNETIC BUTTON EFFECT, Gold CTAs
  ============================================================ */
  var magneticSelectors = '.btn-gold, .hero-tel-btn, .reviews-cta-btn';
  section.querySelectorAll(magneticSelectors).forEach(function (btn) {
    btn.style.transition = 'transform 0.35s cubic-bezier(0.23, 1, 0.32, 1)';
    var strength = 0.3;
    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var x = (e.clientX - rect.left - rect.width / 2) * strength;
      var y = (e.clientY - rect.top - rect.height / 2) * strength;
      btn.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = '';
    });
  });

  (function () {
    var track = document.getElementById('teamTrack');
    var prevBtn = document.getElementById('teamPrev');
    var nextBtn = document.getElementById('teamNext');
    var dotsContainer = document.getElementById('teamDots');
    if (!track || !prevBtn || !nextBtn) return;
    var cards = Array.from(track.children);
    var currentIndex = 0;
    function getVisibleCount() { var w = window.innerWidth; if (w <= 480) return 1; if (w <= 768) return 2; if (w <= 1024) return 3; return 4; }
    function buildDots() {
      dotsContainer.innerHTML = '';
      var totalPages = Math.ceil(cards.length / getVisibleCount());
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'team-carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function(idx) { dot.addEventListener('click', function () { currentIndex = Math.min(idx * getVisibleCount(), cards.length - getVisibleCount()); update(); }); })(i);
        dotsContainer.appendChild(dot);
      }
    }
    function getCardWidth() { if (!cards[0]) return 0; var gap = parseFloat(window.getComputedStyle(track).gap) || 20; return cards[0].getBoundingClientRect().width + gap; }
    function update() {
      var visibleCount = getVisibleCount();
      var maxIndex = Math.max(0, cards.length - visibleCount);
      currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
      track.style.transform = 'translateX(-' + (currentIndex * getCardWidth()) + 'px)';
      var currentPage = Math.round(currentIndex / visibleCount);
      dotsContainer.querySelectorAll('.team-carousel-dot').forEach(function (dot, i) { dot.classList.toggle('active', i === currentPage); });
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }
    prevBtn.addEventListener('click', function () { currentIndex = Math.max(0, currentIndex - getVisibleCount()); update(); });
    nextBtn.addEventListener('click', function () { currentIndex = Math.min(cards.length - getVisibleCount(), currentIndex + getVisibleCount()); update(); });
    var touchStartX = 0, touchStartY = 0, isDragging = false;
    track.parentElement.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; isDragging = false; }, { passive: true });
    track.parentElement.addEventListener('touchmove', function (e) { var dx = Math.abs(e.touches[0].clientX - touchStartX); var dy = Math.abs(e.touches[0].clientY - touchStartY); if (dx > dy && dx > 8) isDragging = true; }, { passive: true });
    track.parentElement.addEventListener('touchend', function (e) { if (!isDragging) return; var diff = e.changedTouches[0].clientX - touchStartX; var vis = getVisibleCount(); if (diff < -40) currentIndex = Math.min(cards.length - vis, currentIndex + vis); else if (diff > 40) currentIndex = Math.max(0, currentIndex - vis); update(); }, { passive: true });
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { var vis = getVisibleCount(); currentIndex = Math.round(currentIndex / vis) * vis; buildDots(); update(); }, 150); }, { passive: true });
    buildDots();
    update();
  })();

  /* ============================================================
     COUNT-UP ANIMATION
  ============================================================ */
  (function () {
    var countEls = section.querySelectorAll('[data-countup]');
    if (!countEls.length || !('IntersectionObserver' in window)) {
      countEls.forEach(function (el) { el.textContent = el.getAttribute('data-countup'); });
      return;
    }
    var countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup'));
        var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var duration = 1600;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = target * eased;
          el.textContent = decimals > 0 ? current.toFixed(decimals) : Math.floor(current).toString();
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = decimals > 0 ? target.toFixed(decimals) : target.toString();
        }
        requestAnimationFrame(step);
        countObserver.unobserve(el);
      });
    }, { threshold: 0.5 });
    countEls.forEach(function (el) {
      el.textContent = '0';
      countObserver.observe(el);
    });
  })();

  /* ============================================================
     LIVE OPEN/CLOSED STATUS
     NZ hours: Mon 9-7, Tue 7-9, Wed 9-7, Thu 7-7, Fri 9-7, Sat-Sun 9-5
  ============================================================ */
  (function () {
    var textEl = document.getElementById('liveStatusText');
    var subEl = document.getElementById('liveStatusSub');
    var dotEl = section.querySelector('.live-status-dot');
    if (!textEl || !subEl) return;

    // Hours: [openHour, openMin, closeHour, closeMin], 24h format, NZ time
    var hours = {
      0: [9, 0, 17, 0],    // Sun
      1: [9, 0, 19, 0],    // Mon
      2: [7, 30, 21, 0],   // Tue
      3: [9, 0, 19, 0],    // Wed
      4: [7, 30, 19, 0],   // Thu
      5: [9, 0, 19, 0],    // Fri
      6: [9, 0, 17, 0]     // Sat
    };
    var dayLabel = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    function formatTime(h, m) {
      var period = h >= 12 ? 'PM' : 'AM';
      var hh = h % 12; if (hh === 0) hh = 12;
      return hh + (m > 0 ? ':' + (m < 10 ? '0' + m : m) : '') + ' ' + period;
    }

    function update() {
      // Get current time in NZ (Pacific/Auckland)
      var now;
      try {
        now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Pacific/Auckland' }));
      } catch (e) {
        now = new Date();
      }
      var day = now.getDay();
      var minutesNow = now.getHours() * 60 + now.getMinutes();
      var today = hours[day];
      var openMin = today[0] * 60 + today[1];
      var closeMin = today[2] * 60 + today[3];
      var isOpen = minutesNow >= openMin && minutesNow < closeMin;

      if (isOpen) {
        textEl.textContent = 'Open Now';
        subEl.textContent = 'Closes ' + formatTime(today[2], today[3]);
        if (dotEl) dotEl.classList.remove('is-closed');
      } else {
        textEl.textContent = 'Closed';
        // Next opening
        var nextDay = day, nextHours, addDays = 0;
        if (minutesNow < openMin) {
          nextHours = today; addDays = 0;
        } else {
          for (var i = 1; i <= 7; i++) {
            nextDay = (day + i) % 7;
            nextHours = hours[nextDay];
            addDays = i;
            break;
          }
        }
        var prefix = addDays === 0 ? 'Opens today ' : (addDays === 1 ? 'Opens tomorrow ' : 'Opens ' + dayLabel[nextDay] + ' ');
        subEl.textContent = prefix + formatTime(nextHours[0], nextHours[1]);
        if (dotEl) dotEl.classList.add('is-closed');
      }
    }
    update();
    setInterval(update, 60000); // refresh every minute
  })();

  /* ============================================================
     STICKY MOBILE BOOKING BAR, show after scrolling past hero
  ============================================================ */
  (function () {
    var bar = document.getElementById('mobileStickyBar');
    var hero = section.querySelector('.awc-hero');
    if (!bar || !hero) return;
    var heroBottom = 0;
    function updateHeroBottom() { heroBottom = hero.offsetTop + hero.offsetHeight - 100; }
    updateHeroBottom();
    window.addEventListener('resize', updateHeroBottom, { passive: true });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > heroBottom) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ============================================================
     TASK 3, H1 WORD STAGGER REVEAL
     Wraps each word in the hero H1 with a .hero-word span,
     then reveals them with staggered delays
  ============================================================ */
  (function () {
    var h1 = section.querySelector('.hero-h1');
    if (!h1) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Collect text nodes and wrap words, preserving <em> and <br>
    function wrapWordsInNode(node, delay) {
      if (node.nodeType === 3) { // text node
        var words = node.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        words.forEach(function (part) {
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else if (part) {
            var span = document.createElement('span');
            span.className = 'hero-word';
            span.style.transitionDelay = delay[0] + 's';
            span.textContent = part;
            delay[0] += 0.14;
            frag.appendChild(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.tagName !== 'BR') {
        Array.from(node.childNodes).forEach(function (child) { wrapWordsInNode(child, delay); });
      }
    }

    var delayCounter = [0];
    Array.from(h1.childNodes).forEach(function (child) { wrapWordsInNode(child, delayCounter); });

    // Trigger reveal slightly after page load
    var heroWords = h1.querySelectorAll('.hero-word');
    setTimeout(function () {
      heroWords.forEach(function (w) { w.classList.add('word-visible'); });
    }, 180);
  })();

  /* ============================================================
     TASK 3, GOLD DIVIDER LINE DRAW ANIMATION
     Triggers via IntersectionObserver on elements with
     class .gold-divider-draw
  ============================================================ */
  (function () {
    var drawDividers = section.querySelectorAll('.gold-divider-draw');
    if (!drawDividers.length || !('IntersectionObserver' in window)) {
      drawDividers.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var drawObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          drawObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    drawDividers.forEach(function (el) { drawObs.observe(el); });
  })();

  /* ============================================================
     TASK 3, STAGGER FADE-UP for grid cards
     Any grid with data-stagger-grid gets its direct children
     staggered with 80ms intervals
  ============================================================ */
  (function () {
    var grids = section.querySelectorAll('[data-stagger-grid]');
    if (!grids.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    grids.forEach(function (grid) {
      var children = Array.from(grid.children);
      children.forEach(function (child) {
        child.classList.add('stagger-child');
        // Remove existing reveal class to avoid conflict
        child.classList.remove('reveal', 'reveal-delay-1', 'reveal-delay-2', 'reveal-delay-3', 'reveal-delay-4');
      });

      var staggerObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          staggerObs.unobserve(entry.target);
          // Find sibling index for delay
          var idx = children.indexOf(entry.target);
          if (idx === -1) idx = 0;
          // Apply stagger delay based on column position (row of 4 → idx % 4)
          var delay = (idx * 80) / 1000;
          entry.target.style.transitionDelay = delay + 's';
          setTimeout(function () {
            entry.target.classList.add('stagger-visible');
          }, 20);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

      children.forEach(function (child) { staggerObs.observe(child); });
    });
  })();

  /* ============================================================
     TASK 3, PARALLAX ON HERO VISUAL
     Subtle Y translation as user scrolls (max 30px offset)
  ============================================================ */
  (function () {
    var visual = document.getElementById('heroVisual');
    if (!visual) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.scrollY || window.pageYOffset;
          var offset = Math.min(scrollY * 0.12, 30);
          visual.style.setProperty('--parallax-y', offset + 'px');
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ============================================================
     TASK 4, ATMOSPHERIC PARTICLES
     Generates 25 golden dots in the hero background
  ============================================================ */
  (function () {
    var container = document.getElementById('heroParticles');
    if (!container) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var count = 25;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'hero-particle';
      var leftPct = (Math.random() * 88 + 4).toFixed(1);
      var bottomPct = (Math.random() * 30).toFixed(1);
      var dur = (6 + Math.random() * 8).toFixed(2);
      var delay = (-(Math.random() * 12)).toFixed(2);
      var dx = ((Math.random() - 0.5) * 60).toFixed(0);
      var opacity = (0.15 + Math.random() * 0.18).toFixed(2);
      var size = Math.random() > 0.6 ? 2 : 3;
      p.style.cssText = [
        'left:' + leftPct + '%',
        'bottom:' + bottomPct + '%',
        '--p-dur:' + dur + 's',
        '--p-delay:' + delay + 's',
        '--p-dx:' + dx + 'px',
        '--p-opacity:' + opacity,
        'width:' + size + 'px',
        'height:' + size + 'px'
      ].join(';');
      container.appendChild(p);
    }
  })();

  /* ============================================================
     TASK 1, SYMPTOM CHECKER QUIZ
  ============================================================ */
  (function () {
    var card = document.getElementById('awcQuizCard');
    if (!card) return;

    // Result lookup table: [area, duration, acc?] → recommendation
    // Keys: area|* or area|duration|coverage
    var recommendations = {
      // ACC injury combinations
      'back_neck|acc':       { icon: '&#129484;', service: 'Chiropractic Care (ACC)', benefit: 'Evidence-based spinal adjustment to relieve back and neck pain, same day claim lodged.', price: '$40/visit', url: 'https://aucklandwellness.co.nz/pages/chiropractor-north-shore-auckland' },
      'disc_nerve|long_term|acc': { icon: '&#127381;', service: 'Spinal Decompression (ACC)', benefit: 'Non-surgical disc decompression for herniated discs, sciatica and chronic nerve pain.', price: '$30/visit', url: 'https://aucklandwellness.co.nz/pages/spinal-decompression-therapy-auckland' },
      'disc_nerve|acc':      { icon: '&#127381;', service: 'Chiropractic + Decompression', benefit: 'Combined chiropractic adjustment and spinal decompression for disc and nerve pain relief.', price: 'From $30', url: 'https://aucklandwellness.co.nz/pages/spinal-decompression-therapy-auckland' },
      'sports_injury|acc':   { icon: '&#127934;', service: 'Sports Chiropractic + TPI', benefit: 'ACC-funded sports injury treatment with TPI performance assessment and functional rehab.', price: '$40/visit', url: 'https://aucklandwellness.co.nz/pages/sports-chiropractor-auckland' },
      'hip_joint|acc':       { icon: '&#129481;', service: 'Chiropractic Care (ACC)', benefit: 'Joint mobilisation, manipulation and soft tissue therapy for hip and joint injuries.', price: '$40/visit', url: 'https://aucklandwellness.co.nz/pages/chiropractor-north-shore-auckland' },
      'posture|acc':         { icon: '&#129489;', service: 'Chiropractic CBP Technique', benefit: 'Postural correction and structural chiropractic care with evidence-based CBP method.', price: '$40/visit', url: 'https://aucklandwellness.co.nz/pages/posture-correction-auckland' },
      // Stress/sleep → always acupuncture regardless of ACC
      'stress_sleep':        { icon: '&#127774;', service: 'Acupuncture &amp; TCM', benefit: 'Traditional Chinese Medicine acupuncture for stress relief, sleep improvement and nervous system balance.', price: 'From $0 (ACC) / $80', url: 'https://aucklandwellness.co.nz/pages/acupuncture-auckland' },
      // Pregnancy → always gentle care
      'pregnancy':           { icon: '&#127801;', service: 'Pregnancy Chiropractic Care', benefit: 'Safe, gentle chiropractic and acupuncture during pregnancy for pelvic pain and comfort.', price: 'From $70', url: 'https://aucklandwellness.co.nz/pages/pregnancy-chiropractor-auckland' },
      // Head/migraine
      'head_migraine':       { icon: '&#129504;', service: 'Chiropractic + Acupuncture', benefit: 'Combined care for cervicogenic headaches, tension headaches and migraines with lasting relief.', price: 'From $40', url: 'https://aucklandwellness.co.nz/pages/headache-migraine-treatment-auckland' },
      // Private / not sure fallbacks
      'back_neck|private':   { icon: '&#129484;', service: 'Chiropractic Care', benefit: 'Evidence-based spinal adjustment and corrective care for lasting back and neck pain relief.', price: '$105 initial / $70 follow-up', url: 'https://aucklandwellness.co.nz/pages/chiropractor-north-shore-auckland' },
      'disc_nerve|private':  { icon: '&#127381;', service: 'Spinal Decompression', benefit: 'Non-surgical decompression for disc herniations, degenerative disc disease and sciatica.', price: '$50/visit', url: 'https://aucklandwellness.co.nz/pages/spinal-decompression-therapy-auckland' },
      'sports_injury|private': { icon: '&#127934;', service: 'Sports Chiropractic + TPI', benefit: 'TPI-certified sports chiropractic for injury recovery and performance improvement.', price: 'From $70', url: 'https://aucklandwellness.co.nz/pages/sports-chiropractor-auckland' },
      // Default fallback
      'default':             { icon: '&#127381;', service: 'Chiropractic Care', benefit: 'Book a comprehensive initial consultation, we\'ll assess your needs and build your care plan.', price: '$105 initial / $40 ACC', url: 'https://aucklandwellness.co.nz/pages/chiropractor-north-shore-auckland' }
    };

    function getRecommendation(area, duration, coverage) {
      // Priority order for lookups
      var keys = [
        area + '|' + duration + '|' + coverage,
        area + '|' + coverage,
        area,
        'default'
      ];
      // Stress/sleep and pregnancy always override
      if (area === 'stress_sleep' || area === 'pregnancy' || area === 'head_migraine') {
        return recommendations[area] || recommendations['default'];
      }
      for (var i = 0; i < keys.length; i++) {
        if (recommendations[keys[i]]) return recommendations[keys[i]];
      }
      return recommendations['default'];
    }

    var answers = { area: null, duration: null, coverage: null };
    var steps = [
      document.getElementById('quizStep1'),
      document.getElementById('quizStep2'),
      document.getElementById('quizStep3')
    ];
    var result = document.getElementById('quizResult');
    var resultService = document.getElementById('quizResultService');
    var resultBenefit = document.getElementById('quizResultBenefit');
    var resultPrice = document.getElementById('quizResultPrice');
    var resultIcon = document.getElementById('quizResultIcon');
    var resultLearn = document.getElementById('quizResultLearn');

    function showStep(idx) {
      steps.forEach(function (s) { if (s) s.classList.remove('active'); });
      if (result) result.classList.remove('active');
      if (steps[idx]) steps[idx].classList.add('active');
    }

    function showResult() {
      steps.forEach(function (s) { if (s) s.classList.remove('active'); });
      var rec = getRecommendation(answers.area, answers.duration, answers.coverage);
      if (resultIcon)    resultIcon.innerHTML = rec.icon;
      if (resultService) resultService.innerHTML = rec.service;
      if (resultBenefit) resultBenefit.textContent = rec.benefit;
      if (resultPrice)   resultPrice.textContent = rec.price;
      if (resultLearn)   resultLearn.href = rec.url;
      if (result)        result.classList.add('active');
    }

    function setupOptionGroup(step, nextBtn, answerKey) {
      if (!step) return;
      var opts = step.querySelectorAll('.awc-quiz-option');
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
          answers[answerKey] = opt.getAttribute('data-value');
          if (nextBtn) nextBtn.disabled = false;
        });
      });
    }

    setupOptionGroup(steps[0], document.getElementById('quizNext1'), 'area');
    setupOptionGroup(steps[1], document.getElementById('quizNext2'), 'duration');
    setupOptionGroup(steps[2], document.getElementById('quizNext3'), 'coverage');

    var next1 = document.getElementById('quizNext1');
    var next2 = document.getElementById('quizNext2');
    var next3 = document.getElementById('quizNext3');
    var back2 = document.getElementById('quizBack2');
    var back3 = document.getElementById('quizBack3');
    var restart = document.getElementById('quizRestart');

    if (next1) next1.addEventListener('click', function () { showStep(1); });
    if (next2) next2.addEventListener('click', function () { showStep(2); });
    if (next3) next3.addEventListener('click', function () { showResult(); });

    if (back2) back2.addEventListener('click', function () { showStep(0); });
    if (back3) back3.addEventListener('click', function () { showStep(1); });

    if (restart) restart.addEventListener('click', function () {
      answers = { area: null, duration: null, coverage: null };
      card.querySelectorAll('.awc-quiz-option').forEach(function (o) { o.classList.remove('selected'); });
      [document.getElementById('quizNext1'), document.getElementById('quizNext2'), document.getElementById('quizNext3')].forEach(function (b) { if (b) b.disabled = true; });
      showStep(0);
    });
  })();

  /* ============================================================
     CUSTOM CURSOR (desktop only, pointer: fine)
  ============================================================ */
  (function () {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var dot = document.createElement('div');
    dot.className = 'awc-cursor-dot';
    var ring = document.createElement('div');
    ring.className = 'awc-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var rx = mx, ry = my;
    var dx = mx, dy = my;
    var active = false;

    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!active) {
        active = true;
        dot.style.opacity = '1';
        ring.style.opacity = '1';
      }
    }, { passive: true });

    window.addEventListener('mouseleave', function () {
      active = false;
      dot.style.opacity = '0';
      ring.style.opacity = '0';
    });

    function animate() {
      dx += (mx - dx) * 0.7;
      dy += (my - dy) * 0.7;
      rx += (mx - rx) * 0.14;
      ry += (my - ry) * 0.14;
      dot.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) translate(-50%,-50%)';
      ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0) translate(-50%,-50%)';
      requestAnimationFrame(animate);
    }
    animate();

    // Grow ring on interactive elements
    var interactiveSel = 'a, button, summary, [role="button"], .condition-card, .service-card, .team-card, .credential-badge, .awc-quiz-option';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(interactiveSel)) {
        ring.classList.add('is-hover');
        dot.classList.add('is-hover');
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(interactiveSel)) {
        ring.classList.remove('is-hover');
        dot.classList.remove('is-hover');
      }
    });
  })();

  /* ============================================================
     SCROLL PROGRESS BAR, Thin gold line at top
  ============================================================ */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var bar = document.createElement('div');
    bar.className = 'awc-scroll-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var scrolled = window.scrollY;
      var height = document.documentElement.scrollHeight - window.innerHeight;
      var progress = height > 0 ? (scrolled / height) : 0;
      bar.style.transform = 'scaleX(' + progress + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* ============================================================
     SECTION REVEAL ENHANCEMENT, observe section transitions
  ============================================================ */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var sections = section.querySelectorAll('.awc-section, .awc-trust-bar, .awc-credentials-strip, .awc-quiz');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('section-in-view');
        }
      });
    }, { threshold: 0.15 });
    sections.forEach(function (s) { obs.observe(s); });
  })();

})();
